import React from 'react'
import { StyleSheet, View, ViewStyle } from 'react-native'
import { ProgressBar } from 'react-native-paper'

import { color } from '../../theme'

interface LineProgressProps {
  isLoading: boolean
  height?: number
  color?: string
  style?: ViewStyle
}

export const LineProgress = (props: LineProgressProps) => {
  const { isLoading, height = 4, style } = props

  return (
    <View style={[styles.progressHeight, style]}>
      <ProgressBar
        color={props.color ?? color.palette.white}
        indeterminate={true}
        visible={isLoading}
        style={{ height }}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  progressHeight: { height: 1, backgroundColor: 'transparent' }
})
